import { Logger } from "../../02_utils/logger";

export class Accordion {
  constructor(private $log: Logger) {
    const accordionButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.js-accordion-button');
    accordionButtons?.forEach((button) => {
      this.openAccordion(button);
    });
  }

  private openAccordion(accordionButton: HTMLElement): void {
    accordionButton.addEventListener('shown.bs.collapse', () => {
      const scrollTop = accordionButton.getBoundingClientRect().top + window.scrollY;
      window.scroll({top: scrollTop - 200 });
      this.$log.debug('scrolled accordion to:', scrollTop - 128);
    });
  }
}
